<template>
  <form action="#" @submit.prevent="submit" :disabled="disabled">
    <fieldset>
      <label for="userPassword">
        {{ $t('resetPasswordForm.passwordLabel') }}
      </label>
      <Input
        v-model="form.password"
        block
        type="password"
        name="userPassword"
        id="userPassword"
        :placeholder="$t('resetPasswordForm.passwordLabel')"
        data-test="password-input"
        required
        :invalid="invalidPassword"
      />
      <transition name="fade">
        <Alert v-if="invalidPassword">
          {{ $t('resetPasswordForm.wrongPasswordFormatMessage') }}
        </Alert>
      </transition>
    </fieldset>
    <fieldset>
      <label for="userConfirmPassword">
        {{ $t('resetPasswordForm.passwordConfirmationLabel') }}
      </label>
      <Input
        v-model="form.confirmPassword"
        block
        type="password"
        name="userConfirmPassword"
        id="userConfirmPassword"
        :placeholder="$t('resetPasswordForm.passwordConfirmationLabel')"
        data-test="password-input"
        required
        :invalid="invalidConfirmationPassword"
      />
      <transition name="fade">
        <Alert v-if="invalidConfirmationPassword">
          {{ $t('resetPasswordForm.wrongConfirmationMessage') }}
        </Alert>
      </transition>
    </fieldset>
    <Button
      block
      type="submit"
      size="lg"
      :loading="loading"
      data-test="submit-button"
    >
      {{ $t('resetPasswordForm.submitButtonText') }}
    </Button>
  </form>
</template>

<script>
import Input from '@/components/Input.vue';
import Alert from '@/components/Alert.vue';
import Button from '@/components/Button.vue';

export default {
  components: {
    Input,
    Alert,
    Button,
  },
  props: {
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    invalidPassword: { type: Boolean, default: false },
    invalidConfirmationPassword: { type: Boolean, default: false },
  },
  data() {
    return {
      form: {
        password: '',
        confirmPassword: '',
      },
    };
  },
  methods: {
    submit() {
      this.$emit('resetPassword', {
        password: this.form.password,
        confirmPassword: this.form.confirmPassword,
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
</style>
